import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import RtLink from '@/lib/rt/RtLink'
import RtFile from '@/lib/rt/RtFile'
import RtIframe from '@/lib/rt/RtIframe'
import RtImage from '@/lib/rt/RtImage'
import RtImageList from '@/lib/rt/RtImageList'
import CTA from '@/lib/CTA'
import * as css from './RichtextSection.module.css'

const components = {
	block: {
		h2: ({ children }) => <h2 className="h2">{children}</h2>,
		h3: ({ children }) => <h3 className="h3">{children}</h3>,
		h4: ({ children }) => <h4 className="h4">{children}</h4>,
	},
	marks: {
		link: RtLink,
		pill: ({ children }) => <span className="pill">{children}</span>,
	},
	types: {
		rtFile: RtFile,
		rtIframe: RtIframe,
		rtImage: RtImage,
		rtImageList: RtImageList,
		cta: ({ value }) => <p className="text-center"><CTA {...value} /></p>,
	},
}

const RichtextSection = ({ heading, _rawRichtext, blockId }) => (
	<section id={blockId} className={`section-md richtext ${css.richtext}`}>
		<HTag className="h1 mb-8" {...heading} />
		<Richtext raw={_rawRichtext} components={components} />
	</section>
)

export default RichtextSection
